module.exports = __webpack_public_path__ + "img/mlb-seattle-mariners-200x200.f258497b.png";